<template>
<div class="chapter">
<div class="inner_page">
<h2 class="title">Erster Teil.<br class="calibre6"/>
Lyrische und epische Form</h2>
<p class="calibre1"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page19" title="wedi/Konmax"></a> <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page20" title="wedi/Konmax"></a></p>
<h3 class="calibre4 sigil_not_in_toc">Weltweh und Himmelssehnsucht</h3>
<p class="vers">Wie eine Windesharfe<br class="calibre2"/>
sei deine Seele,<br class="calibre2"/>
Dichter!<br class="calibre2"/>
Der leiseste Hauch<br class="calibre2"/>
bewege sie.</p>
<p class="vers">Und ewig müssen<br class="calibre2"/>
die Saiten schwingen<br class="calibre2"/>
im Atem des Weltwehs;<br class="calibre2"/>
denn das Weltweh<br class="calibre2"/>
ist die Wurzel<br class="calibre2"/>
der Himmelssehnsucht.</p>
<p class="vers">Also steht deiner Lieder<br class="calibre2"/>
Wurzel begründet<br class="calibre2"/>
im Weh der Erde;<br class="calibre2"/>
doch ihren Scheitel krönet<br class="calibre2"/>
Himmelslicht.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?075df982